import dynamic from "next/dynamic";

import type { Props as PostiesQuizProps } from "scmp-app/components/posties/quiz";

export const DynamicPostiesQuiz = dynamic<PostiesQuizProps>(() =>
  import("scmp-app/components/posties/quiz").then(module => module.PostiesQuiz),
);
